// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"CreateStudent_breadcrumbs__lXBmO","container":"CreateStudent_container__B0zt1"};